// extracted by mini-css-extract-plugin
export default {"withoutScroll":"plain-badges-group_withoutScroll__7XwkT","placeHolderShimmer":"plain-badges-group_placeHolderShimmer__0cvCh"};